// extracted by mini-css-extract-plugin
export var emailBlockLink = "_fz-0";